import { useEffect, useMemo, useState } from "react";

import Card from "../UI/Card";
import MealItem from "./MealItem/MealItem";
import classes from "./AvailableMeals.module.css";
import categorizeMeal from "../../utils/categorizeMeal";
import normalizeName from "../../utils/normalizeName";

const AvailableMeals = ({ activeCategory }) => {
  const [meals, setMeals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [httpError, setHttpError] = useState();

  useEffect(() => {
    setIsLoading(true);
    const fetchMeals = async () => {
      const response = await fetch(
        "https://react-food-app-edad2-default-rtdb.firebaseio.com/Meals.json"
      );
      if (!response.ok) {
        throw new Error("Something went wrong!");
      }
      const responseData = await response.json();
      const loadedMeals = [];

      for (const key in responseData) {
        const meal = responseData[key];
        const normalizedName = normalizeName(meal.name);
        const category = categorizeMeal(meal);
        loadedMeals.push({
          id: key,
          name: meal.name,
          description: meal.description,
          price: meal.price,
          category,
          normalizedName,
        });
      }
      setMeals(loadedMeals);
      setIsLoading(false);
    };

    fetchMeals().catch((error) => {
      setIsLoading(false);
      setHttpError(error.message);
    });
  }, []);

  const filteredMeals = useMemo(() => {
    const normalizedActive = (activeCategory || "all").toLowerCase();
    let base = meals;
    if (normalizedActive === "all") {
      base = meals;
    } else {
      base = meals.filter((meal) => meal.category === normalizedActive);
    }
    return [...base].sort((a, b) => a.name.localeCompare(b.name));
  }, [activeCategory, meals]);

  if (isLoading) {
    return (
      <section className={classes.MealsLoading}>
        <p>Loading...</p>
      </section>
    );
  }

  if (httpError) {
    return (
      <section className={classes.MealsError}>
        <p> {httpError}</p>
      </section>
    );
  }

  const mealsList = filteredMeals.map((meal) => (
    <MealItem
      key={meal.id}
      id={meal.id}
      name={meal.name}
      description={meal.description}
      price={meal.price}
      category={meal.category}
    />
  ));

  return (
    <section className={classes.meals}>
      <Card>
        {filteredMeals.length === 0 ? (
          <p className={classes.emptyState}>
            No meals in this category yet. Try switching tabs.
          </p>
        ) : (
          <ul className={classes.grid}>{mealsList}</ul>
        )}
      </Card>
    </section>
  );
};

export default AvailableMeals;
